import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { hideCustomMedia } from 'aria-viewer/tour/tourActions'
import { showDescription } from 'aria-viewer/tour/components/buttons/desktopAudioButton'
import Icon from 'aria-viewer/tour/components/icon'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import QueryParamUtils from 'aria-viewer/utils/queryParamUtils'
import { Browser } from '../../../legacy'

const isPhone = Browser.is('mobile')

const SBase = {
    mobile: { bottom: '4em' },
    desktop: { bottom: '8em' },
}

const S = {
    icon: {
        position: 'absolute',
        right: '18px',
        bottom: '48%',
        width: '17.8px',
        height: '10px',
        transform: 'translateY(50%) rotateZ(-90deg)',
        backgroundSize: 'cover',
    },
}

// TODO : memoize different permutations of
// TODO : button container style
class SkipButton extends PureComponent {
    handleOnClick = () => {
        const allowAutoCaptions = QueryParamUtils.isQueryValuePresentAndEqual('vt-auto-caption', 'true', 'false')

        const { hideCustomMedia, player, showDescription } = this.props

        player && player.setVolume(0)

        hideCustomMedia && hideCustomMedia()
        allowAutoCaptions && showDescription()
    }

    handleKeyPress = e => {
        if (e.key == 'Enter') {
            this.handleOnClick(e)
        }
    }

    render() {
        const { theme, title, isSkipButtonVisible, tabIndex } = this.props

        return (
            <div
                id="skip_intro"
                onClick={!isPhone ? this.handleOnClick : undefined}
                onTouchStart={isPhone ? this.handleOnClick : undefined}
                tabIndex={tabIndex}
                role="button"
                data-ada-first
                onKeyPress={this.handleKeyPress}
                style={Object.assign(
                    {},
                    {
                        color: '#fff',
                        fontSize: '15px',
                        width: '118px',
                        background: styleguide.colors.transparentBlack,
                        borderRadius: '3px',
                        padding: '12.8px 18px',
                        position: 'absolute',
                        right: 0,
                        zIndex: 2003,
                        cursor: 'pointer',
                        pointerEvents: 'all',
                        opacity: isSkipButtonVisible ? 1 : 0,
                        transition: 'opacity 150ms ease-in',
                    },
                    SBase[theme]
                )}
            >
                {title}
                <Icon icon="arrowDown" style={S.icon} />
            </div>
        )
    }
}
export default connect(mapSelectorsToProps(['isSkipButtonVisible']), {
    hideCustomMedia,
    showDescription,
})(SkipButton)
